module.exports = __webpack_public_path__ + "assets/img/like-on.a972baa3.svg";